import React from "react";

const ServiceCard = ({ icon, title, subtitle }) => (
  <div className="service-card">
    <img className="service-icon" src={icon} alt={title} />
    <div className="service-title">{title}</div>
    <div className="service-sub">{subtitle}</div>
  </div>
);

export default function Services() {
  return (
    <div className="services container">
      <h3>USŁUGI</h3>
      <div className="services-grid">
        <ServiceCard icon="images/skrzynka.png" title="Konserwacja" subtitle="regularne przeglądy" />
        <ServiceCard icon="images/klucz.png" title="Naprawa" subtitle="szybka reakcja" />
        <ServiceCard icon="images/kolo.png" title="Montaż" subtitle="fachowe wykonanie" />
        <ServiceCard icon="images/lupa.png" title="Diagnoza" subtitle="identyfikacja problemów" />
      </div>
    </div>
  );
}
